import React, { useState } from 'react';
import { Col, Row, Input, Label } from 'reactstrap';

// Redux
import { connect } from 'react-redux';

//Componentes
import CustomModal from '../../../components/modales/customModal';

const axios = require('axios')

const mapStateToProps = state => ({
    usuarioActivo: state
})

const ModalExportacionAPE = (props) => {
    let todayDate = new Date(Date.now())
    const [startDate, setStartDate] = useState(new Date(todayDate.getFullYear(), todayDate.getMonth() - 1, todayDate.getDate()))
    const [endDate, setEndDate] = useState(new Date(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate()))
    const [ok, setOk] = useState(true)

    return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                title={'Exportar Reporte'}
                buttonTitle={'Exportar'}
                enableOk={ok && startDate.getTime() < endDate.getTime()}
                onClick={() => props.action({ start: startDate.toISOString().split('T')[0], end: endDate.toISOString().split('T')[0] })}
            // buttonLoading={cancelando}
            >
                <Row>
                    <Col lg='6' md='6' xs="12" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                        <Label for="exampleSelect">Fecha de Inicio</Label>
                        <Input
                            id="startDate"
                            name="datetime"
                            value={startDate ? startDate.toISOString().split('T')[0] : new Date(Date.now().getTime() + 86400000).toISOString().split('T')[0]}
                            onChange={(e) => setStartDate(new Date(e.target.value))}
                            type="date"
                        />
                    </Col>
                    <Col lg='6' md='6' xs="12" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                        <Label for="exampleSelect">Fecha de Fin</Label>
                        <Input
                            id="endDate"
                            name="datetime"
                            value={endDate ? endDate.toISOString().split('T')[0] : new Date(Date.now().getTime() + 86400000).toISOString().split('T')[0]}
                            onChange={(e) => {
                                setOk(true)
                                setEndDate(new Date(e.target.value))
                            }}
                            type="date"
                        />
                    </Col>
                </Row>
            </CustomModal>
        </React.Fragment>
    );
}

export default connect(mapStateToProps)(ModalExportacionAPE);